module.exports = __webpack_public_path__ + "static/media/rd-book-splash.17aa6aa0.png";